const styles = (theme) => ({
	container: {
		width: "100%",
		borderRadius: "10px",
		px: "20px",
		py: "14px",
		display: "grid",
		gridTemplateColumns: { xs: "1fr", md: "auto minmax(0, 1fr) auto" },
		alignItems: "center",
		gap: { xs: 1.5, md: 3 },
	},
	skeleton: {
		width: "100%",
		height: "68px",
		borderRadius: "10px",
	},
	total: {
		display: "flex",
		alignItems: "baseline",
		gap: 1,
	},
	numeroTotal: {
		fontSize: "1.9rem",
		fontWeight: 600,
		lineHeight: 1,
		color: theme.palette.text.primary,
		fontVariantNumeric: "tabular-nums",
	},
	rotulo: {
		color: theme.palette.text.secondary,
	},
	barra: {
		display: "flex",
		gap: "3px",
		height: "12px",
		borderRadius: "4px",
		overflow: "hidden",
		backgroundColor: theme.palette.action.hover,
	},
	segmento: (cor, peso) => ({
		flex: peso,
		backgroundColor: cor,
	}),
	contadores: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 2,
	},
	contador: {
		display: "flex",
		alignItems: "center",
		gap: "6px",
	},
	ponto: (cor) => ({
		width: "8px",
		height: "8px",
		borderRadius: "2px",
		backgroundColor: cor,
	}),
	valor: (cor) => ({
		fontSize: "0.85rem",
		fontWeight: 600,
		color: cor || theme.palette.text.primary,
		fontVariantNumeric: "tabular-nums",
	}),
	separador: {
		width: "1px",
		height: "18px",
		backgroundColor: theme.palette.divider,
	},
});

export default styles;
